import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AssetManager from "../../common/AssetManager";
import CustomSelect, {
  CustomSelectOption,
} from "../../common/components/CustomSelect";
import WikiCategoryCard from "../../common/components/WikiCategoryCard";
import WikiModal from "../../common/components/WikiModal";
import { Context as FormDataContext } from "../../context/formContext/FormContext";
import { PairWikiCategory } from "../../context/formContext/types";

const wikiCategories: WikiCategory[] = AssetManager.getAsset(
  "/wiki_category_db.json"
)["categories"];

const AgeLocationSelect = () => {
  const {
    state: formState,
    selectAgeLocationPairByID,
    selectActivity,
  } = useContext(FormDataContext);
  const {
    ageLocationPairs,
    selectedAgeLocationPair: selectedPair,
    selectedActivity,
    ageLocationPair,
  } = formState;
  const { i18n } = useTranslation();
  const [activityOptions, setActivityOptions] = useState<
    CustomSelectOption[] | null
  >(null);
  const [selectedActivityIndex, setSelectedActivityIndex] = useState<
    number | ""
  >("");

  const [wikiOpen, setWikiOpen] = useState<boolean>(false);
  const [wikiIDList, setWikiIDList] = useState<number[]>([]);

  useEffect(() => {
    setSelectedActivityIndex("");
    createActivityCommentOptions();
  }, [selectedPair]);

  function createActivityCommentOptions() {
    if (selectedPair) {
      const lsPairs = selectedPair.locationSweatCommentPairs;
      const activityOptions: CustomSelectOption[] = [];

      for (let i = 0; i < lsPairs.length; i++) {
        const lsPair = lsPairs[i];

        activityOptions.push({
          value: i,
          label:
            i18n.t("activity_location_" + lsPair.location) +
            (lsPair.sweatComment !== null
              ? " - " + i18n.t("activity_sweatComment_" + lsPair.sweatComment)
              : ""),
        });
      }

      setActivityOptions(activityOptions);
    }
  }

  function handleOpenWikiCategory(wiki: PairWikiCategory) {
    setWikiIDList(wiki.wikiList);
    setWikiOpen(true);
  }

  return (
    <>
      <div className="age-location-container">
        <div className="age-location-inner-container">
          <div className="d-flex flex-column">
            <h5 className="input-label">{i18n.t("form_select_age_group")}</h5>
            <CustomSelect
              options={ageLocationPairs.map((pair) => {
                return { label: i18n.t(pair.ageNameKey), value: pair.pairID };
              })}
              value={selectedPair === "" ? selectedPair : selectedPair.pairID}
              selectValue={(option: number | "") => {
                selectAgeLocationPairByID(option);
              }}
            ></CustomSelect>
          </div>

          {selectedPair && activityOptions && (
            <div className="d-flex flex-column">
              <h5 className="input-label">{i18n.t("form_select_activity")}</h5>
              <CustomSelect
                options={activityOptions}
                value={selectedActivityIndex}
                selectValue={(option: number | "") => {
                  setSelectedActivityIndex(option);
                  selectActivity(
                    option !== ""
                      ? selectedPair.locationSweatCommentPairs[option]
                      : ""
                  );
                }}
              ></CustomSelect>
            </div>
          )}
        </div>

        <>
          {ageLocationPair && selectedActivity !== "" && (
            <>
              <p className="description">
                {i18n.t("age_group_select_wiki_description")}
              </p>
              <div className="wiki-list">
                {selectedActivity.wikiCategories?.map((wiki, index) => (
                  <WikiCategoryCard
                    key={index}
                    wikiCategories={wikiCategories}
                    pairWikiCategory={wiki}
                    onClick={() => {
                      handleOpenWikiCategory(wiki);
                    }}
                  ></WikiCategoryCard>
                ))}
              </div>
            </>
          )}
        </>
      </div>
      {wikiOpen && (
        <WikiModal
          open={wikiOpen}
          setOpen={setWikiOpen}
          wikiIDList={wikiIDList}
        ></WikiModal>
      )}
    </>
  );
};

export default AgeLocationSelect;

export interface WikiCategory {
  categoryId: number;
  wikiCategoryNameKey: string;
}
